import React from 'react';
import SessionManager from './SessionManager';

const TopNavigation = ({ onBack, onLogout }) => {
  return (
    /* 상단 네비게이션 바 - 고정 영역: 네비게이션 + 헤더 + 사용 가이드 */
    <nav className="top-navigation">
      <div className="nav-left">
        {onBack && (
          <button onClick={onBack} className="btn btn-back">
            ← 메뉴로
          </button>
        )}
      </div>
      <div className="nav-center">
        <SessionManager 
          onLogout={onLogout}
          showInNavigation={true}
        />
      </div>
      <div className="nav-right">
        <button onClick={onLogout} className="btn btn-logout">
          🚪 로그아웃
        </button>
      </div>
    </nav>
  );
};

export default TopNavigation;